import { useMemo, useEffect, useState, useRef } from "react";
import { debounce } from "lodash";

export const useDebouncedAsyncSelect = (fetcher, delay = 500) => {
    const lastRequestId = useRef(0);

    return useMemo(() => {
        const loadOptions = (inputValue, callback) => {
            const requestId = ++lastRequestId.current;

            fetcher(inputValue)
                .then((data) => {
                    // solo responde si es la última request
                    if (requestId === lastRequestId.current) {
                        callback(data || []);
                    }
                })
                .catch(() => {
                    if (requestId === lastRequestId.current) {
                        callback([]);
                    }
                });
        };

        return debounce(loadOptions, delay);
    }, [fetcher, delay]);
};

export const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
